import React, { Component } from 'react';
import { connect } from 'react-redux';
import { checkIfSpecimenOverlayIsVisible } from '../../redux/reducers';
import { toggleCadessOverlay, updateCadessDataForSpecimen, resetCadessData } from '../../redux/actions';
import { SpecimenFormContainer, SpecimenImage, SpecimenOverlayButton } from '..';
import Chevron from '../../assets/images/chevron.svg';

const mapStateToProps = state => {
  const {
    selectedSpecimen,
    renderSeadragon: openSeadragonShouldBeRendered,
    currentPathologist,
    showForm: reportFormShouldBeRendered,
  } = state._case;

  const { status } = state.cadessData;

  const { user } = state.auth;

  return {
    selectedSpecimen,
    specimenOverlayIsVisible: checkIfSpecimenOverlayIsVisible(state),
    openSeadragonShouldBeRendered,
    currentPathologist,
    reportFormShouldBeRendered,
    user,
    status,
  };
};
class SpecimenView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      formButtonClass: 'specimen-report__button-collapse',
      formClass: 'specimen-report',
      collapseContainer: '',
      collapsedFormBackground: '',
    };
  }

  componentDidMount() {
    if (!this.props.selectedSpecimen || !this.props.selectedSpecimen.cadessId) {
      return null;
    }
    return this.props.updateCadessDataForSpecimen(this.props.selectedSpecimen);
  }

  componentDidUpdate(prevProps) {
    const { selectedSpecimen } = this.props;
    if (selectedSpecimen.cadessId !== prevProps.selectedSpecimen.cadessId) {
      return this.props.updateCadessDataForSpecimen(selectedSpecimen);
    }
    return null;
  }
  componentWillUnmount() {
    this.props.resetCadessData();
  }

  // Changes the classes depending on if the report is collapsed or not.
  // The collapse and it's animation is handled in _specimenView.scss
  handleCollapse = () => {
    if (this.state.formClass === 'specimen-report') {
      this.setState({
        formClass: 'specimen-report-collapse',
        formButtonClass: 'specimen-report__button-collapse-collapsed',
        collapseContainer: 'specimen-report-collapse-container',
        collapsedFormBackground: 'specimen-report-collapsed-background',
      });
    } else {
      this.setState({
        formClass: 'specimen-report',
        formButtonClass: 'specimen-report__button-collapse',
        collapseContainer: '',
        collapsedFormBackground: '',
      });
    }
  };

  render() {
    const {
      selectedSpecimen,
      openSeadragonShouldBeRendered,
      reportFormShouldBeRendered,
      specimenOverlayIsVisible,
      status,
    } = this.props;
/*
              <SpecimenOverlayButton
                cadessStatus={status}
                onClick={this.props.toggleCadessOverlay}
                cadessOverlayIsVisible={specimenOverlayIsVisible}
              />*/
    return (
      <div className="main-content specimen-content-wrapper">
        <section className="specimen-image">
          {openSeadragonShouldBeRendered && reportFormShouldBeRendered && (
            <React.Fragment>
              <SpecimenImage
                cadessStatus={status}
                specimenId={selectedSpecimen._id}
                imgUrl={selectedSpecimen.imgUrl}
                cadessImgUrl={selectedSpecimen.cadessImgUrl}
                cadessOverlayIsVisible={specimenOverlayIsVisible}
                openSeadragonShouldBeRendered={openSeadragonShouldBeRendered}
              />

            </React.Fragment>
          )}
        </section>

        <section className={this.state.formClass}>
          <div className={this.state.collapseContainer}>
            {reportFormShouldBeRendered && <SpecimenFormContainer />}
          </div>
        </section>

        <div className={this.state.collapsedFormBackground} />
        {/* makes the collapsed form stretch over the whole page. Just a styling choice */}
        <div className={this.state.formButtonClass} onClick={this.handleCollapse}>
          <img src={Chevron} alt="Collapse icon" />
        </div>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  {
    toggleCadessOverlay,
    updateCadessDataForSpecimen,
    resetCadessData,
  },
)(SpecimenView);
